<template>
  <div class="callout" :class="variantClass">
    <slot />
  </div>
</template>

<script>
export default {
  name: "CareCallout",
  props: {
    variant: {
      type: String,
      default: "default",
      validator: (v) => ["default", "yellow", "blue"].includes(v),
    },
  },
  computed: {
    variantClass() {
      if (this.variant === "yellow") return "callout-yellow";
      if (this.variant === "blue") return "callout-blue";
      return "";
    },
  },
};
</script>
